import React, { useState, useEffect, useContext } from "react";
import { Box } from "@mui/system";
import {
  TextField,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  Button,
} from "@mui/material";
import Sidebar from "./sidebar";
import DataContext from "../context/context";
import getDropDownData from "./hook/getDropDownData";

import {
  addDoc,
  collection,
} from "firebase/firestore";
import { db } from "../firebase";
import { mergeActivityNames } from "../utils/activityNames";

export default function LogActivity() {
  const dropdata = useContext(DataContext);

  // State variables for the form fields
  const [activityName, setActivityName] = useState("");
  const [activityDate, setActivityDate] = useState("");
  const [summary, setSummary] = useState("");
  const [duration, setDuration] = useState("");
  const [logAttendance, setLogAttendance] = useState("");
  const [dropDownData, setdropDownData] = useState("");

  const pushData = async () => {
    let main = {
      id: Date.now(),
      activityName,
      activityDate,
      summary,
      duration,
      logAttendance,
    };
    console.log(main);
    await addDoc(collection(db, "LogActivity"), main);
    reset();
  };

  let reset = () => {
    setActivityName("");
    setActivityDate("");
    setSummary("");
    setDuration("");
    setLogAttendance("");
  };
  useEffect(() => {
    setdropDownData(dropdata);
    if (!dropdata) {
      getRewindData();
    }
  }, [dropdata]);

  let getRewindData = async () => {
    let a = await getDropDownData();
    setdropDownData(a);
  };

  const activityOptions = mergeActivityNames(dropDownData?.LogActivity);

  return (
    <Box sx={{ display: "flex" }}>
      <Sidebar />

      <Box
        component="main"
        sx={{ flexGrow: 1, p: 3 }}
        style={{
          marginTop: "50px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ height: 640, width: "100%" }}>
          <div className="LoginPage">
            <FormControl style={{ width: "45%" }}>
              <InputLabel id="demo-simple-select-label">
                Activity Name
              </InputLabel>
              <Select
                value={activityName}
                onChange={(e) => setActivityName(e.target.value)}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Activity Name"
              >
                {activityOptions.map((val) => (
                  <MenuItem key={val} value={val}>
                    {val}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              type="date"
              InputLabelProps={{ shrink: true }}
              className="addform"
              id="outlined-basic"
              label="Activity Date"
              variant="outlined"
              style={{ width: "45%" }}
              onChange={(e) => setActivityDate(e.target.value)}
              value={activityDate}
            />

            <TextField
              className="addform"
              id="outlined-basic"
              label="Summary"
              variant="outlined"
              style={{ width: "100%" }}
              multiline
              rows={4}
              onChange={(e) => setSummary(e.target.value)}
              value={summary}
            />

            <TextField
              type="number"
              className="addform"
              id="outlined-basic"
              label="Duration (Hours)"
              variant="outlined"
              style={{ width: "45%" }}
              onChange={(e) => setDuration(e.target.value)}
              value={duration}
            />

            <TextField
              type="number"
              className="addform"
              id="outlined-basic"
              label="Log Attendance"
              variant="outlined"
              style={{ width: "45%" }}
              onChange={(e) => setLogAttendance(e.target.value)}
              value={logAttendance}
            />

            <Button
              onClick={pushData}
              className="addform"
              variant="contained"
              style={{
                width: "100%",
                height: "50px",
                marginTop: "30px",
                backgroundColor: "#F21D2F",
              }}
            >
              Submit
            </Button>
          </div>
        </div>
      </Box>
    </Box>
  );
}
